module.exports = __webpack_public_path__ + "img/HSZHSY_common.30256c49.png";